export const subPermissionsKeys = {
  groupKey: 'blackboard',

  blackboardMigrationList: 'courses-obtener-cursos-horarios-blackboard',
};

